import clone from "clone";

/**
 * Copy Arrays
 */
export const copyArray = (records: any) => {
  return clone(records);
}